const routers = [
{
  path: '/',
  meta: { title: '首页' },
  redirect: '/system/index'
},
{
  path: '/system/login',
  meta: {
    title: '系统管理用户登陆'
  },
  component: (resolve) => require(['../views/system/frame/login.vue'], resolve)
},
{
  path: '/system/sealStat',
  meta: {
    title: '系统管理用户登陆'
  },
  component: (resolve) => require(['../views/system/sealStat/sealStat.vue'], resolve)
},
{
  path: '/noPage/404',
  meta: {
    title: '页面丢失'
  },
  component: (resolve) => require(['../views/system/frame/noPage.vue'], resolve)
}]
export default routers